
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lessons/[lessonId]",
      function () {
        return require("private-next-pages/lessons/[lessonId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lessons/[lessonId]"])
      });
    }
  